import React from 'react';
import styled from 'styled-components';
import sendAnalyticEvent from 'services/analytic/analytic-service';
import { Button, gridConfig } from '@tvg/fuse-design';
import IconShare from '@tvg/fuse-icons/lib/Share';
import appWebhook from '@sd-utility/appwebhook';
import { GetValidMediaUrl } from 'utilities/media/media-util';
import { SiteName } from 'types/Site';

type Props = {
  productName: string;
  platform: string;
  site: SiteName;
  image: string;
};

const StyledButton = styled(Button)`
  padding: 10px 24px 10px 18px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid var(--Base-black, #000);
  background: var(--Base-white, #fff);
  @media (min-width: ${gridConfig.l.minWidth}) {
    padding: 12px 32px 12px 20px;
  }
`;

function ShareButton(props: Props) {
  const { productName, platform, site, image } = props;

  const mediaUrl = GetValidMediaUrl(site);

  const productImage = `${mediaUrl}/${image}.jpg?$200x200_socialshare$`;

  const handleAppWebHook = () => {
    appWebhook('share', {
      image: productImage,
      link: `${window.location.origin}${window.location.pathname}`,
      product: {
        name: productName,
        url: `${window.location.origin}${window.location.pathname}`,
      },
    });
  };

  const handleShare = () => {
    sendAnalyticEvent({
      gaAction: 'Click',
      gaLabel: 'Share',
    });
    if (platform === 'web') {
      navigator.share({
        url: `${window.location.origin}${window.location.pathname}`,
        title: productName,
      });
    } else {
      handleAppWebHook();
    }
  };

  return (
    <StyledButton
      variant="tertiary"
      onClick={handleShare}
      data-testid="share-icon-container"
      size={{
        xxs: 'medium',
        xl: 'large',
      }}
      fullWidth="true"
      icon={
        <IconShare
          title="share"
          width="20px"
          height="20px"
          desc="share icon for share button"
          dataTestId="share-icon"
        />
      }
    >
      Share
    </StyledButton>
  );
}

export default ShareButton;
